import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { authClient } from '../authClient';
import { takeReturnPath } from '../helpers/returnPath';

const LoginCallback: React.FC = () => {
  const navigate = useNavigate();
  // The sign-in response can only be processed once; StrictMode runs effects twice in development.
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    authClient.userManager
      .signinRedirectCallback()
      .then(() => {
        navigate(takeReturnPath(), { replace: true });
      })
      .catch((err: Error) => {
        console.error('Login callback error:', err);
        // e.g. the callback page was refreshed; /login sends signed-in users on.
        navigate('/login', { replace: true });
      });
  }, [navigate]);

  return <div>Processing login...</div>;
};

export default LoginCallback;
